<template>
  <div id="confiance" class="container px-8 pt-16 mx-auto lg:px-16">
    <div class="flex flex-col md:flex-row">
      <img
        class="self-center object-contain md:p-8 mb-4 md:w-1/2 md:order-2"
        src="@/assets/img/thierryBedossa.jpg"
        alt
        srcset
      />
      <div class="flex flex-col justify-center md:w-1/2 md:order-1 md:mr-8">
        <h2
          id="fonctionnement"
          class="text-3xl font-bold tracking-wider uppercase font-raleway"
        >
          Thierry Bedossa
        </h2>
        <hr class="mb-10 border border-green-500" />
        <p class="mb-10">
          Le collier HerdingCats et sa technologie sont reconnus des
          comportementalistes ! Thierry Bedossa, vétérinaire comportementaliste
          et spécialiste du chien et du chat est associé au projet. Il
          représente une réelle caution scientifique et une confirmation du
          besoin lié au collier tant pour les propriétaires que pour les
          vétérinaires.<br />
          Thierry Bedossa concrétise son engagement dans le bien-être animal
          grâce à son refuge
          <a
            href="https://avarefuge.fr/"
            class="text-green-500 focus:underline hover:underline"
            >AVA (Agir pour la Vie Animale)</a
          >
          . Il a accepté de mettre à notre disposition une vingtaine de ses
          chats afin de tester notre nouveau prototype. Une chance inespérée
          pour HerdingCats de récolter énormément de data ainsi qu’un gage de
          confiance de cet expert envers le projet.
        </p>
        <!-- <a href="#" v-scroll-to="'#footer'"
          class="block px-4 py-4 font-bold leading-none tracking-wider text-center text-white uppercase bg-green-500 rounded-full shadow-md hover:bg-green-400 hover:shadow-lg">
          Découvrir HerdingCats en avant-première
        </a>-->
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
